import { capitalCase } from 'change-case'
export default {
    computed: {
        frequencies() {
            const { frequencies } =
                this.$store.getters['company/assetFrequencies']
            console.log({ frequencies })
            const _frequencies = (frequencies || []).map(
                ({ name, value: id }) => ({
                    name,
                    id,
                })
            )

            _frequencies.unshift({ id: '0', name: 'One-Off' })
            return _frequencies
        },

        weekDays() {
            return [
                { id: 0, name: 'Sunday' },
                { id: 1, name: 'Monday' },
                { id: 2, name: 'Tuesday' },
                { id: 3, name: 'Wednesday' },
                { id: 4, name: 'Thursday' },
                { id: 5, name: 'Friday' },
                { id: 6, name: 'Saturday' },
            ]
        },
        contact_options() {
            const contacts = this.customer_contacts
            console.log('contacts', contacts)
            return contacts.map(x => ({
                id: x.id,
                name: x.first_name + ' ' + x.last_name,
            }))
        },
    },
    watch: {},
    methods: {
        getLabel({ field, label, required }, isTrueLabel = false) {
            try{
                if (!label) {
                    if (field === 'customer_id') label = 'Belong To'
                    else if (field === 'location_section_id') label = 'Location'
                    else if (field === 'order_template_id') label = 'Activity Template'
                    else {
                        const list = field.split('_')
                        ///remove last item if equal to id or url
                        if (['id', 'url'].some(x => x == list.at(-1))) {
                            list.pop()
                        }
                        label = capitalCase(list.join(' '))
                    }
                }
            }catch(err){
                console.log('asseterr', field, label, required)
            }
            return `${label}${isTrueLabel && required ? '<span class="red">*</span>' : ''}`
        },
        getOptions(field) {
            const arr = (() => {
                switch (field) {
                    case 'manufacturer_id':
                        return this.vendors || []
                    case 'vendor_id':
                        return this.vendors || []
                    case 'type_id':
                        return this.types || []
                    case 'customer_id':
                        return this.customers || []
                    case 'frequency':
                        return this.frequencies
                    case 'interaction_type_id':
                        return this.interactionTypes || []
                    case 'service_day_of_week':
                        return this.weekDays
                    case 'default_engineer_id':
                        return this.engineers
                    case 'order_template_id':
                        return this.orderTypes
                    case 'customer_contact_id':
                        return this.contact_options
                }
            })()

            return arr.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },
        getValue(field, asset) {
            switch (field) {
                case 'manufacturer_id':
                    return asset.manufacturer.name
                case 'vendor_id':
                    return asset.vendor.name
                case 'customer_id':
                    return asset.customer.name
                case 'type_id':
                    return asset.type.name
                case 'frequency':
                    return (
                        this.frequencies.find(x => x.id === asset[field]) || {}
                    ).name
                case 'location_section_id':
                    return asset.location_section.name
                case 'manual_url':
                case 'service_plan_url':
                case 'image_url': {
                    try {
                        return JSON.parse(asset[field])
                    } catch (err) {
                        //console.log('err', err)
                        return { name: asset[field], key: asset[field] }
                    }
                }
                default:
                    return asset[field]
            }
        },
    },
}
